<template>
  <aside class="admin-sidebar">
    <div class="logo">
      <router-link to="/"></router-link>
    </div>
    <nav class="sidebar-nav">
      <el-menu router>
        <template v-for="(item, index) in navList">
          <!-- 二级 -->
          <el-submenu v-if="item.children" :key="`menu_${index}`" :index="`menu_${index}`">
            <template slot="title">
              <i :class="item.iconClassName"></i>
              <span>{{item.name}}</span>
            </template>
            <el-menu-item v-for="(menu, i) in item.children" :key="`menu_${index}_${i}`" :index="menu.href">
              {{menu.name}}
            </el-menu-item>
          </el-submenu>
          <!-- 一级 -->
          <el-menu-item v-else :key="`menu_${index}`" :index="item.href">
            <i :class="item.iconClassName"></i>
            <span slot="title">{{item.name}}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </nav>
  </aside>
</template>
<script>
export default {
  data: () => ({
    navList: [
      {
        name: '文章管理',
        iconClassName: 'el-icon-edit-outline',
        href: '/admin/article'
        // children: [
        //   { name: '新建', href: '/admin/article/add' },
        //   { name: '列表', href: '/admin/article' }
        // ]
      },
      {
        name: '商品管理',
        iconClassName: 'el-icon-goods',
        href: '/admin/good'
      },
      {
        name: '验票管理',
        iconClassName: 'el-icon-search',
        href: '/admin/ticket/inspectTicket'
      },
      {
        name: '订单管理',
        iconClassName: 'el-icon-sold-out',
        href: '/admin/order'
      },
      {
        name: '销售统计',
        iconClassName: 'el-icon-tickets',
        href: '/admin/volume'
      }
    ]
  })
}
</script>
<style>
.admin-sidebar {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 200px;
  background-color: #3f3f3f;
  z-index: 101;
}
.admin-sidebar .logo {
  height: 56px;
  background: #323232 url('../../../assets/img/admin/logo_v2.png') no-repeat
    center center;
  background-size: 72px 34px;
}
.admin-sidebar .logo a {
  display: block;
  height: 100%;
}
.admin-sidebar .sidebar-nav {
  position: relative;
  width: 200px;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}
.admin-sidebar .el-menu {
  border-right: 0;
  background-color: transparent;
}
.admin-sidebar .el-menu-item,
.admin-sidebar .el-submenu__title,
.admin-sidebar .el-menu-item i {
  color: #fff;
}
.admin-sidebar .el-menu-item:focus,
.admin-sidebar .el-menu-item:hover,
.admin-sidebar .el-submenu__title:hover {
  background-color: transparent;
}

.admin-sidebar .el-menu-item.is-active {
  color: #fff;
  background-color: #1589ee;
}
</style>
